<template>
  <el-form :model="instance" :rules="rules" ref="publicRobForm" class="system-public-pool-rob-form-con">
    <div class="clearfix rule-con mt20">
      <p class="desc floatL"><b>分配客户数量上限</b>：</p>
      <div class="desc floatL">
        <el-radio-group v-model="public_allocation_limit_rule">
          <el-radio :label="0">
            <span class="checkbox-label">无上限</span>
          </el-radio>
          <el-radio :label="1">
            <span class="checkbox-label">有上限</span>
          </el-radio>
        </el-radio-group>
      </div>
      <el-popover placement="top-start" trigger="hover">
        <div class="popover-info">
          <p>保存成功后立即生效</p>
        </div>
        <i class="iconfont popover-info-icon" slot="reference">&#xe7e2;</i>
      </el-popover>
    </div>
    <div class="clearfix rule-con" v-if="public_allocation_limit_rule == 1">
      <div class="floatL desc lingqu-reusult">
        1 个有分配权限的账号在 1 个自然日内 ，总共能手动分配
        <el-form-item prop="public_allocation_limit_num" class="mb0 inline-block" :rules="rules.public_allocation_limit_num">
          <el-input v-model.number="public_allocation_limit_num" size="mini" clearable />
        </el-form-item>
        名客户给经纪人
      </div>
    </div> 
    <div class="clearfix rule-con mt20">
      <p class="desc floatL"><b>公客池手动抢客功能</b>：</p>
      <div class="desc floatL">
        <el-radio-group v-model="public_pick_status">
          <el-radio :label="0">
            <span class="checkbox-label">禁用</span>
          </el-radio>
          <el-radio :label="1">
            <span class="checkbox-label">启用</span>
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="rule-group-back mt20" v-if="public_pick_status == 1">
      <div class="clearfix rule-con">
        <p class="desc floatL">不可抢客人员：</p>
        <el-popover placement="top-start" trigger="hover">
          <div class="popover-info">
            <p>设置的人员可以查看公客池列表，但不能参与抢客。</p>
          </div>
          <i class="iconfont popover-info-icon" slot="reference">&#xe7e2;</i>
        </el-popover>
        <div class="desc floatL dis-auto-users">
          <template v-if="no_public_customer_admin_arr.length > 0">
            <span class="person" v-for="(user, i) in no_public_customer_admin_arr" :key="`no_public_customer_admin_arr_${user.id}`">
              {{user.name}}
              <i class="iconfont iconguanbi" @click="removePublicUser(i)"></i>
            </span>
            <p class="person-total">共<span>{{no_public_customer_admin_arr.length}}</span>人</p>
          </template>
          <el-button icon="el-icon-plus" size="mini" @click="addPublicManual">添加</el-button>
        </div>
      </div>
      <div class="clearfix rule-con mt20">
        <p class="desc floatL">抢客规则限制：</p>
        <div class="desc floatL ml10">
          <el-radio-group v-model="instance.pick_freq_status">
            <el-radio :label="0">
              <span class="checkbox-label">禁用</span>
            </el-radio>
            <el-radio :label="1">
              <span class="checkbox-label">启用</span>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="public-robs" v-if="instance.pick_freq_status == 1">
        <div class="clearfix rule-con mt10">
          <div class="desc floatL">
            <el-form-item prop="pick_freq_time_num" class="mb0 num-form" style="float:left">
              <el-input v-model.number="instance.pick_freq_time_num"   size="mini" class="unit-form"></el-input>
            </el-form-item>
            <el-select v-model="instance.pick_freq_time_unit" size="mini" class="unit-form">
              <el-option :value="1" label="小时">小时</el-option>
              <el-option :value="2" label="天">天</el-option>
            </el-select>
          </div>
          <p class="desc floatL ml20">内不能连续领取同一个客户
            <el-popover placement="top-start" trigger="hover">
              <div class="popover-info">
                <p>客户被扔入公客池后，历史归属人在单位时间内不能领取</p>
              </div>
              <i class="iconfont popover-info-icon floatR" slot="reference">&#xe7e2;</i>
            </el-popover>
          </p>
        </div>
        <div class="clearfix rule-con mt10">
          <p class="desc floatL">每个经纪人（特殊经纪人除外）</p>
          <div class="desc floatL public-rob-flex">
            <span>1</span>
            <el-select v-model="instance.public_pick_freq_time_unit" size="mini" class="unit-form">
              <el-option :value="1" label="小时">小时</el-option>
              <el-option :value="2" label="天">天</el-option>
              <el-option :value="3" label="周">周</el-option>
              <el-option :value="4" label="月">月</el-option>
            </el-select>
          </div>
          <div class="desc floatL public-rob-flex">
            <span>最多可抢</span>
            <el-form-item prop="public_pick_freq_limit" class="mb0 num-form">
              <el-input v-model.number="instance.public_pick_freq_limit" size="small" />
            </el-form-item>
          </div>
          <p class="desc floatL ml20">个客户</p>
        </div>
        <div class="pt10">
          <div class="specitial-con" v-for="(item, index) in (instance.public_pick_freq_time || [])" :key="index">
            <span class="label">特殊经纪人</span>
            <div class="spe-flex">
              <span class="items" v-for="(user, i) in item.children" :key="`automitic_${user.id}`">
                {{user.name}}
                <i class="iconfont iconguanbi" @click="removeUser(i, index)"></i>
              </span>
            </div>
            <a class="increase" @click="addPublicPickManual(item.children, index)">添加人员</a>
            <div class="max-num">
              1
              <el-select v-model="item.unit" class="pl10" size="mini">
                <el-option :value="1" label="小时">小时</el-option>
                <el-option :value="2" label="天">天</el-option>
                <el-option :value="3" label="周">周</el-option>
                <el-option :value="4" label="月">月</el-option>
              </el-select>
            </div>
            <div class="max-num">
              最多可抢
              <el-form-item :prop="`public_pick_freq_time[${index}].num`" :rules="rules.admin_list" class="mb0 inline-block">
                <el-input v-model.number="item.num" size="mini"/>
              </el-form-item>
              个客户
            </div>
            <a class="remove" @click="removePublicPickFreq(index)">
              <i class="iconfont">&#xe673;</i>删除
            </a>
          </div>
          <el-button class="mt15 global-btn primary add-special-btn" icon="el-icon-plus" @click="addPublicPickFreq" v-if="instance.public_pick_freq_time.length < 10">特殊经纪人</el-button></el-button>
        </div>
      </div>
    </div>
    <select-company-member ref="publicRobRef" @confirm="handleConfirmRob"/>
    <div class="clearfix rule-con mt20">
      <p class="desc floatL"><b>公客池客户重新归属给经纪人后，是否重置客户等级为未知</b>：</p>
      <div class="desc floatL">
        <el-radio-group v-model="public_level_rule">
          <el-radio :label="0">
            <span class="checkbox-label">不重置客户等级</span>
          </el-radio>
          <el-radio :label="1">
            <span class="checkbox-label">重置客户等级</span>
          </el-radio>
        </el-radio-group>
      </div>
      <el-popover placement="top-start" trigger="hover">
        <div class="popover-info">
          <p>保存成功后立即生效</p>
        </div>
        <i class="iconfont popover-info-icon" slot="reference">&#xe7e2;</i>
      </el-popover>
    </div>
  </el-form>
</template>
<script>
import SelectCompanyMember from '../../../components/selectCompanyMember';
import {validateNum, validateUser,validateNum2} from '../../validateProp';
export default{
  name: 'PublicRob',
  components: {SelectCompanyMember},
  props: {
    info: Object
  },
  watch: {
      public_pick_status: {
          handler (newVal,oldVal){
              this.$EventBus.$emit('changePublicSave',newVal !== this.info.public_pick_status, "rob");
          }
      },
      public_level_rule: {
        handler (newVal,oldVal){
              this.$EventBus.$emit('changePublicSave',newVal !== this.info.public_level_rule, "rob");
          }
      },
      public_allocation_limit_rule: {
        handler (newVal,oldVal){
              this.$EventBus.$emit('changePublicSave',newVal !== this.info.public_allocation_limit_rule, "rob");
          }
      },
      public_allocation_limit_num: {
        handler (newVal,oldVal){
              this.$EventBus.$emit('changePublicSave', newVal !== this.info.public_allocation_limit_num, "rob");
          }
      },
      no_public_customer_admin_arr: {
          handler (newVal, oldVal){
            this.$EventBus.$emit('changePublicSave', this.public_pick_status !== this.info.public_pick_status || JSON.stringify(newVal) !== JSON.stringify(this.sourceNPCA), "rob");
          },
          deep: true
      },
      instance: {
          handler (newVal, oldVal){
              this.$EventBus.$emit('changePublicSave', this.public_pick_status !== this.info.public_pick_status || JSON.stringify(newVal) !== JSON.stringify(this.sourceInfo), "rob");
          },
          deep: true
      }
  },
  data () {
    const validateAgentNum = (rule, data, callback) => {
      const value = this.public_allocation_limit_num;
      if (!(!!value)) {
        callback(new Error(`请输入${rule.name}`))
      } else if (!/^[0-9]{0,4}$/.test(value)) {
        callback(new Error(`${rule.name}为最大9999的整数`))
      } else {
        callback()
      }
    }
    return {
      public_pick_status: 0,
      public_level_rule: 0,
      public_allocation_limit_rule: 0,
      public_allocation_limit_num: 0,
      instance: {
        pick_freq_time_unit: 2,
        pick_freq_status: 0,
        public_pick_freq_time_unit: 1,
        public_pick_freq_limit: '',
        public_pick_freq_time: [],
      },
      no_public_customer_admin_arr: [],
      rules: {
        pick_freq_time_num:[{validator: validateNum2, trigger: 'blur',name: '时间'}],
        public_pick_freq_limit: [
          {validator: validateNum, trigger: 'blur', name: '数量'}
        ],
        admin_list: [
          {validator: validateUser, trigger: 'blur'}
        ],
        public_allocation_limit_num: [
          {validator: validateAgentNum, trigger: 'blur', name: '数量'}
        ]
      },
      sourceNPCA: [],
      sourceInfo: {}
    }
  },
  created() {
    this.initial();
  },
  methods: {
    initial () {
      this.public_pick_status = this.info.public_pick_status;
      this.public_level_rule = this.info.public_level_rule;
      this.public_allocation_limit_rule = this.info.public_allocation_limit_rule;
      this.public_allocation_limit_num = this.info.public_allocation_limit_num;
      this.instance = {
        pick_freq_time_unit: Number(this.info.pick_freq_time_unit || 2),
        pick_freq_time_num:Number(this.info.pick_freq_time_num || null),
        pick_freq_status: Number(this.info.pick_freq_status || 0),
        public_pick_freq_time_unit: Number(this.info.public_pick_freq_time_unit || 1),
        public_pick_freq_limit: this.info.public_pick_freq_limit || '',
      }
      // 特殊经纪人
      if (this.info.public_pick_freq_time) {
        const list= (this.info.public_pick_freq_time || []).map(item => {
          item.children.map(el =>{
            el.id = el.admin_id;
            el.name = el.admin_name;
            return el;
          })
          return item;
        });
        this.$set(this.instance, 'public_pick_freq_time', list);
      } else {
        this.instance.public_pick_freq_time = [{num:"", unit:1}];
      }
      // 公客池不可见
      this.no_public_customer_admin_arr = this.info.no_public_customer_admin_arr || [];

      this.sourceNPCA = JSON.parse(JSON.stringify(this.no_public_customer_admin_arr));
      this.sourceInfo = JSON.parse(JSON.stringify(this.instance));
    },
    // 添加特殊经纪人栏
    addPublicPickFreq(){
      this.instance.public_pick_freq_time.push({num:"", unit:1, children:[]});
    },
    // 移除特殊经纪人栏
    removePublicPickFreq(index) {
      this.$confirm('确认删除该项设置？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(_ => {
        this.instance.public_pick_freq_time.splice(index, 1);
      }).catch(e => {})
    },
    // 移除已选择经纪人
    removeUser (index, itemIndex) {
      this.instance.public_pick_freq_time[itemIndex].children.splice(index, 1);
    },
    // 确认添加经纪人
    handleConfirmRob (list, {category}) {
      if (category == 1) {
        this.instance.public_pick_freq_time[this.publicPickIndex].children =  list;
      } else if (category == 2) {
        this.no_public_customer_admin_arr = list;
      }
    },
    // 打开添加经纪人框
    addPublicPickManual(data, key) {
      this.publicPickIndex = key;
      if (this.$refs.publicRobRef) {
        this.$refs.publicRobRef.open([...data], 1, {category: 1});
      }
    },
    // 打开添加不可见人员弹窗
    addPublicManual () {
      if (this.$refs.publicRobRef) {
        this.$refs.publicRobRef.open([...this.no_public_customer_admin_arr], 1, {category: 2});
      }
    },
    // 移除不可见人员
    removePublicUser (index) {
      this.no_public_customer_admin_arr.splice(index, 1);
    },
    getResults () {
      return new Promise(resolve => {
        this.$refs.publicRobForm.validate(valid => {
          if (!valid) {
            resolve({status: false});
            return null;
          }
          const data = {
            public_pick_status: this.public_pick_status,
            public_level_rule: this.public_level_rule,
            public_allocation_limit_rule: this.public_allocation_limit_rule,
            public_allocation_limit_num: this.public_allocation_limit_num,
            no_public_customer_admin: ''
          }
          // 手动抢客启用
          if (data.public_pick_status == 1) {
            data.pick_freq_time_unit = this.instance.pick_freq_time_unit;
            data.pick_freq_time_num = this.instance.pick_freq_time_num;
            data.pick_freq_status = this.instance.pick_freq_status;
            // 抢客限制启用
            if (data.pick_freq_status == 1) {
              data.public_pick_freq_time_unit = this.instance.public_pick_freq_time_unit;
              data.public_pick_freq_limit = this.instance.public_pick_freq_limit;
              if (this.instance.public_pick_freq_time.length) {
                this.instance.public_pick_freq_time.forEach(item => {
                  if(item.children.length > 0){
                    item.admin_ids = item.children.map(v => v.id).join(",")
                  } else {
                    item.admin_ids = '';
                  }
                })
                data.public_pick_freq_time = this.instance.public_pick_freq_time;
              } else {
                data.public_pick_freq_time = [];
              }
            }
          }
          // 公客池不可见人员
          if (this.no_public_customer_admin_arr.length > 0) {
            data.no_public_customer_admin = this.no_public_customer_admin_arr.map(v => v.id).join(',');
          }
          resolve({status: true, data});
        })
      })
    }
  },
}
</script>
<style lang="less" scoped>
.bus-set-conta .system-public-pool-rob-form-con{
  .specitial-con{
    position: relative;
    width: 830px;
    .remove{
      position: absolute;
      right: -60px;
      top: 17px;
    }
  }
}
.popover-info-icon{
  line-height: 32px;
  float: left;
  margin-left: 2px;
}
.dis-auto-users{
  max-width: calc(100% - 155px)!important;
}
.floatR{
  float: right !important;
}
</style>
<style lang="less">
.system-public-pool-rob-form-con .el-form-item__error{
  min-width: 200px;
  margin-left: 10px;
  margin-top: 5px;
}
</style>
